export enum COLOR {
    PURPLE = "#403C8C",
    GRAY="gray",
    VIOLET="#220141"
}

export enum FONT_SIZE {
    HEADERS="28px",
    EXPLANATION_WIDTH="300px"
}